import {useContext} from 'react';
import {connect} from 'react-redux';

import Portal from 'topmeteo/general/components/Portal';

import {LengthContext} from '../Drawing';

import TotalDistance from './TotalDistance';
import FAIDistance from './FAIDistance';

const CalculationBox = ({FAIEnabled}) => {
    const {length, FAILength} = useContext(LengthContext);
    const showFAIDistance = FAIEnabled && FAILength > 0;

    return (
        <Portal container="map-wrapper">
            <div className="calculation-box">
                <div className="calculation-box-inner">
                    <TotalDistance length={length} />
                    {showFAIDistance && <FAIDistance length={FAILength} />}
                </div>
            </div>
        </Portal>
    );
};

const mapStateToProps = ({FAIEnabled}) => ({FAIEnabled});

export default connect(mapStateToProps)(CalculationBox);
